"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
const _excluded = ["title", "description"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const brandedcheckmark = _ref => {
  let {
      title,
      description
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 56 58",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? "title-brandedcheckmark" : '') + (description ? " desc-brandedcheckmark" : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedcheckmark"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedcheckmark"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M28 58C12.5627 58 0 45.4373 0 30C0 14.5627 12.5627 2 28 2C43.4373 2 56 14.5627 56 30C56 45.4373 43.4373 58 28 58ZM28 5.48135C14.4824 5.48135 3.48135 16.4824 3.48135 30C3.48135 43.5176 14.4824 54.5187 28 54.5187C41.5176 54.5187 52.5187 43.5176 52.5187 30C52.5187 16.4824 41.5176 5.48135 28 5.48135Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M27.7518 32.7843C27.3358 32.8829 27.2565 32.6462 27.0188 32.4095C24.998 30.3677 21.8479 24.4595 19.5498 23.4238C15.1813 21.461 11.3081 25.939 13.7647 30.1606C14.9633 32.2122 22.9277 42.6281 24.5522 43.93C26.9594 45.8731 30.5552 44.9953 32.4274 42.6971C35.31 39.166 39.2822 31.1075 41.5804 26.807C43.3733 23.4534 45.0276 20.0012 46.7116 16.5884C47.2367 15.5133 47.9301 14.4579 48.4353 13.4025C49.2376 11.7159 51.516 7.37591 51.8528 5.89639C53.0811 0.629279 46.3055 -2.32977 43.304 2.29621C42.3828 3.72642 41.6101 5.51171 40.7978 7.03069C40.2926 7.98745 39.827 9.00339 39.3218 9.97001C35.3694 17.5156 31.516 25.1302 27.7518 32.7646V32.7843Z",
    fill: "#F26B1C"
  }));
};
var _default = exports.default = brandedcheckmark;